import { escapeHtml } from 'src/shared/utilities/string';

/**
 * Escapes a text value bound for a `v-html` sink (BUG-21); anything that is
 * not a string (undefined, null, an array rendered as text) passes through.
 */
export function escapeText<T>(value: T): T {
  return (typeof value === 'string' ? escapeHtml(value) : value) as T;
}
